module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mps-entity-editor vue-rqf bg-loading",
    attrs: {
      "loading": _vm.$root.ui.loading
    }
  }, [_c('div', {
    staticClass: "mps-admin-container"
  }, [_c('h4', [_vm._v("Innstillinger"), (_vm.company.id) ? _c('span', {
    domProps: {
      "textContent": _vm._s(' for ' + _vm.company.name)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-name"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.name),
      expression: "company.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('name')
    },
    attrs: {
      "id": "c-name",
      "name": "name",
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.company.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('name')),
      expression: "errors.has('name')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('name'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-slug"
    }
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.slug),
      expression: "company.slug"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|slug'),
      expression: "'required|slug'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('name')
    },
    attrs: {
      "id": "c-slug",
      "name": "slug",
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.company.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "slug", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('slug')),
      expression: "errors.has('slug')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('slug'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-email"
    }
  }, [_vm._v("Epost")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.email),
      expression: "company.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "id": "c-email",
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.company.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('email'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-discount"
    }
  }, [_vm._v("Discount (%)")]), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.discount),
      expression: "company.discount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('between:0,100'),
      expression: "'between:0,100'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('discount')
    },
    attrs: {
      "id": "c-discount",
      "name": "discount",
      "type": "text",
      "placeholder": "Discount (%)"
    },
    domProps: {
      "value": (_vm.company.discount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.company, "discount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('discount')),
      expression: "errors.has('discount')"
    }],
    staticClass: "help is-danger",
    domProps: {
      "textContent": _vm._s(_vm.errors.first('discount'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-type"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    class: ['mps-input-wrap', 'mps-admin-select']
  }, [_c('v-select', {
    attrs: {
      "options": _vm.types,
      "label": "slug"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    class: ['mps-input-wrap', 'mps-admin-select']
  }, [_c('v-select', {
    attrs: {
      "options": _vm.statuses
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.is_partner),
      expression: "company.is_partner"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "c-is_partner",
      "name": "is_partner",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.is_partner) ? _vm._i(_vm.company.is_partner, null) > -1 : _vm._q(_vm.company.is_partner, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.is_partner,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company, "is_partner", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company, "is_partner", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company, "is_partner", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.is_fleet),
      expression: "company.is_fleet"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "c-is_fleet",
      "name": "is_fleet",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.is_fleet) ? _vm._i(_vm.company.is_fleet, null) > -1 : _vm._q(_vm.company.is_fleet, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.is_fleet,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company, "is_fleet", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company, "is_fleet", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company, "is_fleet", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-disabled_workshops"
    }
  }, [_vm._v("Disabled workshops")]), _vm._v(" "), _c('div', {
    class: ['mps-input-wrap', 'mps-admin-select'],
    staticStyle: {
      "max-width": "70%"
    }
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Velg verksted",
      "multiple": "",
      "options": _vm.filteredWorkshops,
      "label": "name"
    },
    model: {
      value: (_vm.disabledWorkshops),
      callback: function($$v) {
        _vm.disabledWorkshops = $$v
      },
      expression: "disabledWorkshops"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company.is_pdf_offer),
      expression: "company.is_pdf_offer"
    }],
    attrs: {
      "true-value": "1",
      "false-value": "0",
      "id": "c-is_pdf_offer",
      "name": "is_pdf_offer",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.company.is_pdf_offer) ? _vm._i(_vm.company.is_pdf_offer, null) > -1 : _vm._q(_vm.company.is_pdf_offer, "1")
    },
    on: {
      "change": function($event) {
        var $$a = _vm.company.is_pdf_offer,
          $$el = $event.target,
          $$c = $$el.checked ? ("1") : ("0");
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.company, "is_pdf_offer", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.company, "is_pdf_offer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.company, "is_pdf_offer", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mps-control"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    class: {
      'control': true, 'mps-input-wrap': true
    },
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "id": "c-logo",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.addImage($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.file.url ? _vm.file.url : _vm.company.logo
    }
  })])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "mps-admin-btn big",
    attrs: {
      "disabled": _vm.errors.any() || _vm.$root.ui.loading
    },
    on: {
      "click": _vm.saveCompany
    }
  }, [_vm._v("Lagre")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-is_partner"
    }
  }, [_c('span', [_vm._v("Is partner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-is_fleet"
    }
  }, [_c('span', [_vm._v("Is fleet")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-is_pdf_offer"
    }
  }, [_c('span', [_vm._v("Add pdf to offer email.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "label",
    attrs: {
      "for": "c-logo"
    }
  }, [_c('span', [_vm._v("Logo")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a97ffe08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./requests/assets/src/components/Company.vue
// module id = 118
// module chunks = 0